import { Wheat, Building2, Landmark, Clapperboard, Users, Scale } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";

const SEGMENTS = [
    {
        icon: Wheat,
        span: "md:col-span-4",
        title: "Agronegócio",
        text: "Contratos agrários, cadeias produtivas, parcerias rurais e operações do agro que exigem julgadores familiarizados com o setor.",
    },
    {
        icon: Building2,
        span: "md:col-span-2",
        title: "Mercado Imobiliário",
        text: "Incorporações, construção civil, locações empresariais e operações imobiliárias estruturadas.",
    },
    {
        icon: Landmark,
        span: "md:col-span-2",
        title: "Gestão Patrimonial & Holdings",
        text: "Planejamento patrimonial, family offices, sucessão empresarial e proteção de ativos relevantes.",
    },
    {
        icon: Clapperboard,
        span: "md:col-span-2",
        title: "Entretenimento & Influência Digital",
        text: "Artistas, músicos, atletas profissionais, influenciadores digitais e empresas dos mercados criativos.",
    },
    {
        icon: Users,
        span: "md:col-span-2",
        title: "Grupos Empresariais & Investidores",
        text: "Operações societárias, acordos de sócios, investimentos privados e solução estruturada de conflitos entre sócios.",
    },
    {
        icon: Scale,
        span: "md:col-span-6",
        wide: true,
        title: "Advocacia & Assessores",
        text: "Escritórios de advocacia e profissionais que assessoram operações de maior complexidade e buscam um ambiente institucional confiável para seus clientes.",
    },
];

export const Segments = () => (
    <section id="segmentos" data-testid="segments-section" className="bg-graphite-dark py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHead
                dark
                eyebrow="Segmentos atendidos"
                title="Conflitos complexos pedem julgadores que entendem do setor"
                lead="A atuação da CAJUSP contempla segmentos estratégicos em que patrimônio, reputação e discrição são especialmente relevantes."
            />

            <div className="mt-16 grid gap-px overflow-hidden rounded-sm border border-graphite-line bg-graphite-line md:grid-cols-6">
                {SEGMENTS.map((s, i) => (
                    <Reveal key={s.title} delay={0.05 * i} className={s.span}>
                        {s.wide ? (
                            <div
                                data-testid={`segment-tile-${i}`}
                                className="group relative flex h-full flex-col bg-graphite-dark px-8 py-10 transition-colors duration-300 hover:bg-graphite md:items-center md:justify-center md:py-12 md:text-center"
                            >
                                <span className="absolute right-8 top-6 font-mono text-[10px] tracking-[0.3em] text-graphite-mute">
                                    0{i + 1}
                                </span>
                                <s.icon
                                    size={28}
                                    strokeWidth={1.4}
                                    className="text-gold transition-transform duration-300 group-hover:-translate-y-1"
                                />
                                <h3 className="mt-5 font-serif text-2xl leading-tight text-cream">
                                    {s.title}
                                </h3>
                                <p className="mt-3 max-w-2xl text-sm leading-relaxed text-graphite-mute md:mx-auto">
                                    {s.text}
                                </p>
                            </div>
                        ) : (
                            <div
                                data-testid={`segment-tile-${i}`}
                                className="group flex h-full min-h-[220px] flex-col bg-graphite-dark p-8 transition-colors duration-300 hover:bg-graphite"
                            >
                                <div className="flex items-start justify-between">
                                    <s.icon
                                        size={26}
                                        strokeWidth={1.4}
                                        className="shrink-0 text-gold transition-transform duration-300 group-hover:-translate-y-1"
                                    />
                                    <span className="font-mono text-[10px] tracking-[0.3em] text-graphite-mute">
                                        0{i + 1}
                                    </span>
                                </div>
                                <div className="mt-10">
                                    <h3 className="font-serif text-2xl leading-tight text-cream">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 text-sm leading-relaxed text-graphite-mute">
                                        {s.text}
                                    </p>
                                </div>
                            </div>
                        )}
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
